class HHHeaderSearch extends HHBaseElement {
  constructor() {
    super()

    this.input = this.querySelector('input[type="search"]')
    this.predictiveSearchResults = this.querySelector('#predictive-search')
    this.resetButton = this.querySelector('.js-header-search-clear')

    // This project uses Boost AI for search, so comment out this snippet
    // this.input.addEventListener(
    //   'input',
    //   this.debounce((event) => {
    //     this.onChange(event)
    //   }, 300).bind(this)
    // )

    // const searchTerm = this.input.value.trim()
    // if (!searchTerm) {
    //   this.fetchData()
    // } else {
    //   this.getSearchResults(searchTerm)
    // }
  }

  connectedCallback() {
    this.resetButton.addEventListener('click', this.resetTerms.bind(this))
    this.addEventListener('showResources', this.showResources.bind(this))
  }

  async fetchData() {
    try {
      const response = await fetch('?section_id=predictive-search')
      const markup = await response.text()

      const parser = new DOMParser()
      const parsedMarkup = parser.parseFromString(markup, 'text/html')
      const resultsMarkup = parsedMarkup.querySelector(
        '#shopify-section-predictive-search'
      ).innerHTML

      this.predictiveSearchResults.innerHTML = resultsMarkup
      this.open()
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  async onChange() {
    const searchTerm = this.input.value.trim()

    if (!searchTerm.length) {
      this.resetButton.setAttribute('disabled', true)
      await this.fetchData()
      return
    }
    this.resetButton.removeAttribute('disabled')

    this.getSearchResults(searchTerm)
  }

  getSearchResults(searchTerm) {
    fetch(
      `/search/suggest?q=${searchTerm}&resources[type]=query,product,collection,page,article&section_id=predictive-search`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status)
          this.close()
          throw error
        }

        return response.text()
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML
        this.predictiveSearchResults.innerHTML = resultsMarkup
        this.open()

        setTimeout(() => {
          this._setupFocusTrap()
        }, 150)
      })
      .catch((error) => {
        this.close()
        throw error
      })
  }

  open() {
    this.predictiveSearchResults.style.display = 'flex'
  }

  close() {
    this.predictiveSearchResults.style.display = 'none'
  }

  debounce(fn, wait) {
    let t
    return (...args) => {
      clearTimeout(t)
      t = setTimeout(() => fn.apply(this, args), wait)
    }
  }

  async resetTerms(e) {
    this.input.value = ''
    this.resetButton.setAttribute('disabled', true)
    await this.fetchData()
    setTimeout(() => {
      this.input.focus()
    }, 150)
  }

  showResources(e) {
    if (!e.detail.key) {
      return
    }

    const resources_header_in_sidebar = this.querySelectorAll('.mobile-search-results-header hh-button')
    resources_header_in_sidebar.forEach(item => {
      if (item.getAttribute('key') === e.detail.key) {
        item.classList.remove('inactivated')
      } else {
        item.classList.add('inactivated')
      }
    })

    const resources_in_sidebar = this.querySelectorAll('[data-resources-key]')
    resources_in_sidebar.forEach(item => {
      if (item.getAttribute('data-resources-key') === e.detail.key) {
        item.classList.remove('inactivated')
      } else {
        item.classList.add('inactivated')
      }
    })
  }
}

customElements.define('hh-header-search', HHHeaderSearch)
